export default "__VITE_ASSET__BwcpPrFb__"